export default {
    namespaced: true,
    state: {
        taPrimary: '#fa5528', // Test-Achats orange
        taSecondary: '#e60078', // Test-Achats magenta
        megaPrimary: '#fdcb47', // mega yellow
        megaSecondary: '#59666f', // mega grey
        primaryThemeColor: '#fa5528', 
        secondaryThemeColor: '#e60078'
    },
    mutations: {
        setPrimaryThemeColor(state, color) {
            state.primaryThemeColor = color;
        },
        setSecondaryThemeColor(state, color) {
            state.secondaryThemeColor = color;
        },
    },
    actions: {
        setThemeTA(ctx) {
            ctx.state.primaryThemeColor = ctx.state.taPrimary;
            ctx.state.secondaryThemeColor = ctx.state.taSecondary;
        }, 
        setThemeMega(ctx) {
            ctx.state.primaryThemeColor = ctx.state.megaPrimary;
            ctx.state.secondaryThemeColor = ctx.state.megaSecondary;
        }
    },
    getters: {
        primaryThemeColor: state => state.primaryThemeColor,
        secondaryThemeColor: state => state.secondaryThemeColor
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/theme.js